import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "./api";
import DashboardView from "./views/DashboardView.vue";
import StudentsView from "./views/StudentsView.vue";
import CardsView from "./views/CardsView.vue";
import DevicesView from "./views/DevicesView.vue";
import LogsView from "./views/LogsView.vue";
import SchoolsView from "./views/SchoolsView.vue";
import ReportsView from "./views/ReportsView.vue";
import SettingsView from "./views/SettingsView.vue";
import LoginView from "./views/LoginView.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/giris",
      name: "login",
      component: LoginView,
      meta: { public: true },
    },
    {
      path: "/",
      name: "dashboard",
      component: DashboardView,
      meta: { title: "Genel Bakış" },
    },
    {
      path: "/ogrenciler",
      name: "students",
      component: StudentsView,
      meta: { title: "Öğrenciler" },
    },
    {
      path: "/kartlar",
      name: "cards",
      component: CardsView,
      meta: { title: "Kartlar" },
    },
    {
      path: "/cihazlar",
      name: "devices",
      component: DevicesView,
      meta: { title: "Cihazlar" },
    },
    {
      path: "/loglar",
      name: "logs",
      component: LogsView,
      meta: { title: "Geçiş Logları" },
    },
    {
      path: "/raporlar",
      name: "reports",
      component: ReportsView,
      meta: { title: "Raporlar" },
    },
    {
      path: "/okullar",
      name: "schools",
      component: SchoolsView,
      meta: { title: "Okullar", superOnly: true },
    },
    {
      path: "/ayarlar",
      name: "settings",
      component: SettingsView,
      meta: { title: "Ayarlar", superOnly: true },
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach((to) => {
  if (!to.meta.public && !getToken())
    return { name: "login", query: { next: to.fullPath } };
  if (to.name === "login" && getToken()) return { name: "dashboard" };
});

export default router;
